import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EndPointService } from 'libs/shared/src/lib/services/end-point.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class ConfigService extends EndPointService {
  private baseHref: string;
  constructor(http: HttpClient, @Inject(APP_BASE_HREF) baseHref: string) {
    super(http);
    if (baseHref == '/') this.baseHref = '.';
    else this.baseHref = baseHref;
    console.log(baseHref);
  }

  public getConfig(): Observable<any> {
    return this.getOrAdd<any, any>(
      `${this.baseHref}/assets/config/configMap/config.json?id=${uuidv4()}`
    ).pipe(
      map((urls) => {
        console.log(urls);
        return urls;
      })
    );
  }
}
